import { jsx } from 'react/jsx-runtime';
import { InputError } from './InputError.js';
import { InputHint } from './InputHint.js';

function InputHintError(props) {
  var _a, _b;
  const inputError = jsx(InputError, Object.assign({}, props));
  const hasTouchedError = ((_a = props.fieldState) === null || _a === void 0 ? void 0 : _a.error) && ((_b = props.fieldState) === null || _b === void 0 ? void 0 : _b.isTouched);
  if (props.errorMessage || hasTouchedError) {
    return inputError;
  }
  return jsx(InputHint, Object.assign({}, props));
}

export { InputHintError };
